import { BaseUrl } from "../api/AxiosApi";



// THIS API FOR DASHBOARD(MAIN) TOP
// export const logApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }) => {


//     // Construct the query parameters dynamically
//     const params = new URLSearchParams({
//         LOGIN_ID,
//         LOC_CODE,
//         PASS_KEY,
//         WEB_KEY,
//     });

//     try {
//         // Fetch the data using the GET method
//         const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_TOT_LIVE_KW_NEW?${params}`, {
//             method: "GET",
//         });

//         if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();
//         return data;
//     } catch (err) {
//         // console.error("API Fetch Error:", err);
//         return null;
//     }
// };


export const logApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }) => {

    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE,
        PASS_KEY,
        WEB_KEY,
    });

    // Final URL
    const finalUrl = `${BaseUrl}CMN_06_DASH_MAIN/GET_TOT_LIVE_KW_NEW?${params}`;

    // Console URL for checking
    console.log("API URL:", finalUrl);

    try {
        // Fetch the data using the GET method
        const response = await fetch(finalUrl, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        // Console response data
        console.log("API Response:", data);

        return data;

    } catch (err) {
        console.error("API Fetch Error:", err);
        return null;
    }
};

// THIS API FOR INVERTDETAILS(GRAPH)

export const InverterDetail2 = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYE }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE,
        PASS_KEY,
        WEB_KEY,
        TYE
    });

    try {
        // Corrected URL (single `?`)

        // CMN_02/Get_FEED_LIST?

        const response = await fetch(`${BaseUrl}CMN_02/Get_FEED_LIST_INV?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};

// THIS API FOR INVERTDETAILS(TABLE)

export const InverterDetail = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE,
        PASS_KEY,
        WEB_KEY

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_02/Get_FEED_LIST?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};

// this is energyreporting (MONTHLY)

export const MonthlyApi = async ({ LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        MT1,
        MT2,
        TYP,
        WEB_KEY,
        FID
    });

    // console.log("Request URL:", `${BaseUrl}CMN_04/GET_MONTH_KWH?${params}`);
    // console.log("Request Params:", { LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID });

    try {
        const response = await fetch(`${BaseUrl}CMN_04/GET_MONTH_KWH?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        // console.log("API Response:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


// this is energyreporting (MONTHLY)
export const MonthlySumApi = async ({ LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        MT1,
        MT2,
        TYP,
        WEB_KEY,
        FID
    });


    // console.log("Request Params:", { LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID });

    try {
        const response = await fetch(`${BaseUrl}CMN_04/GET_MONTH_DATA_SUM?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        // console.log("API Response:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};

// Hourlyapi(energyReporting)

export const HourlyApi = async ({
    LOGIN_ID,
    PASS_KEY,
    LCODE,
    DT1,
    DT2,
    TYP,
    WEB_KEY,
    FID,
}) => {


    // console.log("API Payload:", { LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID });

    const formData = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        DT1,
        DT2,
        TYP,
        WEB_KEY,
        FID,
    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_04/post_KWH_HOUR`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};



//Energy PLANT_01
export const MonthlySumPlant1Api = async ({ LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID, SUB_PLANT }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID, SUB_PLANT
    });

    // console.log("Request Params:", { LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID, SUB_PLANT });



    try {
        const response = await fetch(`${BaseUrl}CMN_04_SUB/GET_MONTH_DATA_SUM_SUB?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        // console.log("API Response:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


export const MonthlyPlant1Api = async ({ LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID, SUB_PLANT }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID, SUB_PLANT
    });


    // console.log("Request Params:", { LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID, SUB_PLANT });

    try {
        const response = await fetch(`${BaseUrl}CMN_04_SUB/GET_MONTH_KWH_SUB?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        // console.log("API Response:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};

export const HourlyPlant1Api = async ({
    LOGIN_ID,
    PASS_KEY,
    LCODE,
    DT1,
    DT2,
    TYP,
    WEB_KEY,
    FID,
    SUB_PLANT
}) => {


    // console.log("API Payload:", { LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID, SUB_PLANT });

    const formData = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        DT1,
        DT2,
        TYP,
        WEB_KEY,
        FID,
        SUB_PLANT
    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_04_SUB/post_KWH_HOUR_SUB`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};



// dash4 (MAIN_SUM)

export const MainSumApi = async ({
    LOGIN_ID,
    PASS_KEY,
    LCODE,
    DT1,
    DT2,
    TYP,
    WEB_KEY,
    FID,
}) => {


    // console.log("API Payload:", { LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID });

    const formData = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        DT1,
        DT2,
        TYP,
        WEB_KEY,
        FID,
    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_04/POST_KWH_MIS_MAIN_SUM`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};


//EnergyHorizontalLog api 

export const EnergyHorizontalLogApi = async ({
    LOGIN_ID,
    PASS_KEY,
    LCODE,
    DT1,
    DT2,
    WEB_KEY,

}) => {
    // console.log("API Payload:", { LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID })
    const formData = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        DT1,
        DT2,
        WEB_KEY,
    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}Power/post_KWH_IRR_H`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};


// this is business dashboard api

export const BusinessApi = async ({
    LOGIN_ID,
    SS_KEY

}) => {


    // console.log("API PayloadBusiness:", { LOGIN_ID, SS_KEY });

    const formData = new URLSearchParams({
        LOGIN_ID,
        SS_KEY

    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_07_Super/POST_USER_SUM_LIST`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};

export const GroupListBusinessApi = async ({
    LOGIN_ID,
    SS_KEY,
    DT1,
    DT2

}) => {


    // console.log("API PayloadBusiness:", { LOGIN_ID, SS_KEY });

    const formData = new URLSearchParams({
        LOGIN_ID,
        SS_KEY,
        DT1,
        DT2

    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_07_Super/POST_USER_SUM_LIST_PARA`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};




export const BusinessWmsApi = async ({
    LOGIN_ID,
    SS_KEY

}) => {


    // console.log("API PayloadBusiness:", { LOGIN_ID, SS_KEY });

    const formData = new URLSearchParams({
        LOGIN_ID,
        SS_KEY

    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_07_Super/POST_USER_SUM_LIST_WMS`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};


export const eventLogReportTableApi = async ({ LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, WEB_KEY, FID }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        DT1,
        DT2,
        WEB_KEY,
        FID
    });

    // console.log("Request URL:", `${BaseUrl}CMN_04/GET_MONTH_KWH?${params}`);
    // console.log("Request Params:", { LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, WEB_KEY, FID });

    try {
        const response = await fetch(`${BaseUrl}CMN_08_EVENT/INV_ALARM_LOG?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        // console.log("API Response:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



// PlantCurve Api
export const plantCurveApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, DT1, DT2 }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE, 
        PASS_KEY,
        WEB_KEY,
        DT1,
        DT2

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_TOT_LOG_KW?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



export const Inverter1ChartApi = async ({
    LOGIN_ID,
    WEB_KEY,
    PASS_KEY,
    DT1,
    DT2,
    MTRNO
}) => {


    // console.log("API Payload:", { LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID });

    const formData = new URLSearchParams({
        LOGIN_ID,
        WEB_KEY,
        PASS_KEY,
        DT1,
        DT2,
        MTRNO
    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_08InvLog/post_INV_LOG`, { 
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};





// Inverter1 Log data

export const Inverter1LogApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID }) => {
 const params = new URLSearchParams({
        LOGIN_ID,PASS_KEY,LCODE,WEB_KEY,DT1,DT2,FID
    });

   try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/GET_LOG_DATA?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
    catch (err) {

        return null;
    }
    return null;

};

// Inverter1 Irddiance 

export const Inverter1IrradianceApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID }) => {
 const params = new URLSearchParams({
        LOGIN_ID,PASS_KEY,LCODE,WEB_KEY,DT1,DT2,FID
    });

   try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/Get_KWH_KW_LOG_FEED?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
    catch (err) {

        return null;
    }
    return null;

};

//Grid Log

export const GridLogApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID }) => {

// Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,PASS_KEY,LCODE,WEB_KEY,DT1,DT2,FID
    });
    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/GET_LOG_DATA?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



export const PrAnalysisApi = async ({
    USER,LCODE,WEB_KEY,PASS_KEY,DT1,DT2,

}) => {
   // console.log("API Payload:", { LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID }
    const formData = new URLSearchParams({
        USER,LCODE,WEB_KEY,PASS_KEY,DT1,DT2,

    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_09_Plant/DAILYSTS_ANALYTIC`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};



// PrAnalysisTab2
export const PrAnalysisTab2Api = async ({ LOGIN_ID, LCODE, PASS_KEY, WEB_KEY, DT1, DT2 }) => {

 // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,LCODE,PASS_KEY,WEB_KEY,DT1,DT2
    });

    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/post_PR_KW?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`); 
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};

// EnergyMeter log api

export const EnergyMeterLogApi = async ({
    LOGIN_ID,
    PASS_KEY,
    WEB_KEY,
    MTR,
    DT1,
    DT2
}) => {
    //

    // console.log("API Payload:", { LOGIN_ID, PASS_KEY, WEB_KEY, MTR, DT1, DT2 });

    const formData = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        WEB_KEY,
        MTR,
        DT1,
        DT2
    });

    // console.log("Form Data:", formData.toString());

    try {
        const response = await fetch(`${BaseUrl}CMN_08InvLog/post_LOG_DATA_MTR`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};



// This is SLD IMAGE API


export const sldApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }) => {
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE,
        PASS_KEY,
        WEB_KEY,
    });

    try {
        // Fetch the data
        const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_SLD?${params}`, {
            method: "GET",
        });

        // console.log("Response Headers:", response.headers.get("content-type"));

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const contentType = response.headers.get("content-type");

        // Check if response is an image
        if (contentType.includes("image")) {
            const blob = await response.blob(); // Convert to Blob
            // console.log("Received Image Blob:", blob);
            return URL.createObjectURL(blob); // Create a local URL for the image
        } else {
            // console.error("API did not return an image");
            return null;
        }
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



// export const plantSldApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }) => {
//     console.clear(); // clear console before fetching
//     // console.log("plantsldapi", LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY)
//     const params = new URLSearchParams({
//         LOGIN_ID,
//         LOC_CODE,
//         PASS_KEY,
//         WEB_KEY,
//     });

//     try {
//         // Fetch the data
//         const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_SLD_PDF?${params}`, {
//             method: "GET",
//         });

//         // console.log("Response Headers:", response.headers.get("content-type"));

//         if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         // const contentType = response.headers.get("content-type");

//         // Check if response is an image
//         const contentType = response.headers.get("content-type");
//         if (contentType.includes("image") || contentType.includes("pdf")) {
//             const blob = await response.blob();
//             return URL.createObjectURL(blob);
//         }

//     } catch (err) {
//         if (process.env.NODE_ENV !== "production") {
//           console.error("API call failed:", err.message);
//         } else {
//           console.error("Something went wrong.");
//         }
//         return null;
//       }

// };

// export const plantSldApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }) => {
//     // Completely clear console (optional)
//     console.clear();

//     // Build query string
//     const params = new URLSearchParams({
//         LOGIN_ID,
//         LOC_CODE,
//         PASS_KEY,
//         WEB_KEY,
//     });

//     try {
//         // ✅ Use fetch + suppress network error visibility
//         const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_SLD_PDF?${params}`, {
//             method: "GET",
//         }).catch(() => {
//             // Swallow low-level fetch/network errors
//             return { ok: false, status: 400 };
//         });

//         if (!response.ok) {
//             // ✅ Don’t throw or log anything — just return null silently
//             return null;
//         }

//         const contentType = response.headers.get("content-type") || "";

//         if (contentType.includes("image") || contentType.includes("pdf")) {
//             const blob = await response.blob();
//             return URL.createObjectURL(blob);
//         }

//         return null;
//     } catch {
//         // ✅ Silent fail — no console output at all
//         return null;
//     }
// };

// export const plantSldApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }) => {
//     try {
//       const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_SLD_PDF`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY }),
//         cache: "no-store",
//       });
  
//       if (!response.ok) return null;
  
//       const contentType = response.headers.get("content-type") || "";
//       if (contentType.includes("pdf") || contentType.includes("image")) {
//         const blob = await response.blob();
//         return URL.createObjectURL(blob);
//       }
  
//       return null;
//     } catch {
//       return null;
//     }
//   };
  

export const plantSldApi = async ({
  LOGIN_ID,
  LOC_CODE,
  PASS_KEY,
  WEB_KEY,
}) => {
  try {
    const url = `${BaseUrl}CMN_06_DASH_MAIN/GET_SLD_PDF` +
      `?LOGIN_ID=${LOGIN_ID}` +
      `&LOC_CODE=${LOC_CODE}` +
      `&PASS_KEY=${PASS_KEY}` +
      `&WEB_KEY=${WEB_KEY}`;

    const response = await fetch(url, {
      method: "GET",        // ✅ MUST BE GET
      cache: "no-store",
    });

    if (!response.ok) return null;

    const blob = await response.blob();

    // 🔥 VERY IMPORTANT
    if (blob.type === "application/pdf") {
      return URL.createObjectURL(blob);
    }

    return null;
  } catch (error) {
    console.error("SLD API Error:", error);
    return null;
  }
};

  

export const EnergyPlant1SldApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, SUB_PLANT }) => {
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE,
        PASS_KEY,
        WEB_KEY,
        SUB_PLANT
    });

    try {
        // Fetch the data
        const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_SLD_SUB?${params}`, {
            method: "GET",
        });

        // console.log("Response Headers:", response.headers.get("content-type"));

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const contentType = response.headers.get("content-type");

        // Check if response is an image
        if (contentType.includes("image")) {
            const blob = await response.blob(); // Convert to Blob
            // console.log("Received Image Blob:", blob);
            return URL.createObjectURL(blob); // Create a local URL for the image
        } else {
            // console.error("API did not return an image");
            return null;
        }
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};

// This is bussiness GroupList Api


export const groupListApi = async ({ User_ID, SKey }) => {
    const params = new URLSearchParams({
        User_ID,
        SKey
    });

    try {
        const response = await fetch(`${BaseUrl}CMN_10_Update/Get_Group_List?${params}`, {
            method: "GET",
        });

        // console.log("Response Headers:", response.headers.get("content-type"));

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const contentType = response.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
            const data = await response.json(); // Parse JSON response
            return data; // Return the actual data
        } else {
            // console.error("Unexpected response format:", contentType);
            return null;
        }
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


// businessHeader api

export const BusinessHeaderApi = async ({ SUSER, SS_KEY, USER_NAME, USER_TYPE }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        SUSER,
        SS_KEY,
        USER_NAME,
        USER_TYPE
    });


    try {

        const response = await fetch(`${BaseUrl}CMN_07_Super/GetUserSum?${params}`, {
            method: "GET",
        });

        // console.log("params response", response)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



//Inverter 1 ac vs dc api

export const Inverter1Tab4Api = async ({ LID, LOC_CODE, pass_key, DT1, DT2, MTR_CODE }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LID,
        LOC_CODE,
        pass_key,
        DT1,
        DT2,
        MTR_CODE

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_08InvLog/GET_DC_AC_KW_DATA?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



//Pr analysis Tab3 api

export const PrAnalysisTab3Api = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID }) => {

    // LOGIN_ID,
    // PASS_KEY,
    // LCODE,
    // WEB_KEY,
    // DT1,
    // DT2,

    // console.log("data credentials:", LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2)

    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        WEB_KEY,
        DT1,
        DT2,
        FID

    });


    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/Get_KWH_KW_LOG_PLANT?${params}`, {
            method: "GET",
        });

        ;

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



//Dailycurtailment api (plant tab3)

export const DailyCurtailmentApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2 }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        WEB_KEY,
        DT1,
        DT2

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/Get_Daily_CURT?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


// Curtailment api
export const CurtailmentDataApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2 }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        WEB_KEY,
        DT1,
        DT2

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/Get_CURT_DET?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("dataapi",data)
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


//Outage api

export const OutageApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2 }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        WEB_KEY,
        DT1,
        DT2

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/Get_OUTAGE_PLANT?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



export const EnergyMeterTab2LogApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID }) => {

    // console.log("ApiEnergyMeterID", FID)
    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        WEB_KEY,
        DT1,
        DT2,
        FID

    });
    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/GET_LOG_DATA?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};

export const BatteryApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID }) => {

    // console.log("ApiEnergyMeterID", FID)
    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        WEB_KEY,
        DT1,
        DT2,
        FID

    });
    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/GET_LOG_DATA?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


export const TotalBatteryPowerApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2 }) => {


    const params = new URLSearchParams({
        LOGIN_ID,
        PASS_KEY,
        LCODE,
        WEB_KEY,
        DT1,
        DT2

    });
    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/Get_BAT_PLANT?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


export const AlaramButtonApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, iROW }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE,
        PASS_KEY,
        WEB_KEY,
        iROW

    });



    try {

        const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/CURR_ALARM?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



export const AlaramLogApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, iROW }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID,
        LOC_CODE,
        PASS_KEY,
        WEB_KEY,
        iROW

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/CURR_ALARM?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};



//This is Tab4plantEnergy

export const Tab4plantEnergyApi = async ({ LOGIN_ID, LCODE, PASS_KEY, WEB_KEY, MT1, MT2, TYP, FID }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID, LCODE, PASS_KEY, WEB_KEY, MT1, MT2, TYP, FID
    });

    try {

        const response = await fetch(`${BaseUrl}CMN_06_DASH_MAIN/GET_MONTH_DASH?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        console.error("API Fetch Error:", err);
        return null;
    }
};



//windrose api

export const WindRoseApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, DT1, DT2, WM_TYPE, DATA_TYPE }) => {

    // console.log("windrose api", LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, DT1, DT2, WM_TYPE, DATA_TYPE)

    const formData = new URLSearchParams({
        LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, DT1, DT2, WM_TYPE, DATA_TYPE
    });
    try {
        const response = await fetch(`${BaseUrl}CMN_02/WM_SENS`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data windrose:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};



//Plant MIS



export const PlantMisApi = async ({ suser, DT1 }) => {


    const formData = new URLSearchParams({
        suser, DT1
    });
    try {
        const response = await fetch(`${BaseUrl}CMN_07_Super/post_SUM_MIS`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });

        // console.log("Response Status:", response.status);

        if (!response.ok) {
            const errorText = await response.text();
            // console.error("API Error Response:", errorText);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Use response.json()
        // console.log("API Response Data plant MIS:", data);

        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err.message);
        return null;
    }
};


//INVERTER PERFORMANCE 

export const InverterPerformanceApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, DT1, DT2, MTR_NO }) => {
    // console.log("logData5Api", LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, DT1, DT2, MTR_NO)


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, DT1, DT2, MTR_NO
    });

    try {

        const response = await fetch(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


//TRANSFORMER GRID

export const TransformerGridApi = async ({ LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, MTR_NO, DT }) => {
    // console.log("logData5Api", LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, MTR_NO, DT)


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, MTR_NO, DT
    });

    try {

        const response = await fetch(`${BaseUrl}CMN_08InvLog/Get_TRANSMON?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


// GroupList Mis

export const GroupListMisApi = async ({ User_ID,
    SKey,
    DT1,
    DT2 }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        User_ID,
        SKey,
        DT1,
        DT2

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_10_Update/Get_Group_List_PARA?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};


// ANALYTICS USER API

export const AnalyticsUserApi = async ({
    USER_ID,
    Password,
    SS_KEY }) => {


    // Construct the query parameters dynamically
    const params = new URLSearchParams({
        USER_ID,
        Password,
        SS_KEY

    });

    try {

        const response = await fetch(`${BaseUrl}CMN_07_Super/GET_USER_LIST?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        // console.error("API Fetch Error:", err);
        return null;
    }
};




export const UserDetailApi = async ({ LOGIN_ID, PASS_KEY, WEB_KEY }) => {
 const params = new URLSearchParams({
        LOGIN_ID,PASS_KEY,WEB_KEY
    });

   try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/Get_USER_DET?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
    catch (err) {

        return null;
    }
    return null;

};

// Inverter hOurly log api 

export const InverterHourlyLogApi = async ({ LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID ,FLT}) => {
    const params = new URLSearchParams({
        LOGIN_ID, PASS_KEY, LCODE, WEB_KEY, DT1, DT2, FID,FLT
    });

    try {

        const response = await fetch(`${BaseUrl}CMN_09_Plant/GET_LOG_DATA_FLT?${params}`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
    catch (err) {

        return null;
    }
    return null;

};